import { FC } from 'react';
import { IconColor } from '../types';

export const StarSvg: FC<{ className?: string; fillColor?: IconColor }> = ({
  className,
  fillColor = IconColor.WHITE,
}) => {
  return (
    <svg
      width="7"
      height="7"
      viewBox="0 0 7 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.5 0L3.92073 3.07927L7 3.5L3.92073 3.92073L3.5 7L3.07927 3.92073L0 3.5L3.07927 3.07927L3.5 0Z"
        fill={fillColor}
      />
    </svg>
  );
};
